__turbopack_context__.v({
  "load-previous": "LoadPrevious-module-scss-module__blYdaq__load-previous",
});
